import React , { useRef, useState } from 'react';
//import { withTranslation } from 'react-i18next/hooks';

import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow, Polyline, Polygon, KmlLayer } from "react-google-maps"

import {Button, Paper} from '@material-ui/core';
import config from '../../../config';
import { decimalColorToHexColor, getObjectByID } from '../../../api/helpers';
import { formatSpeed } from '../../api/Settings';
import { formatDateTime } from '../../../api/date';
import DrawingManager from 'react-google-maps/lib/components/drawing/DrawingManager';

export const MapPanel = withScriptjs(withGoogleMap((props) => {
    let defaultCenter
    let defaultZoom
    let center = null
    let zoom = null
    

    const [currentMarkerID, setMarker] = useState(null);
    const [infoVisibility, setInfoVisibility] = useState(false);
    const [tick, setTick] = useState(0);
    const [drawingManagerEnabled, setDrawingManagerEnabled] = useState(false)

    const drawingManagerRef = useRef();
    const drawingRef = useRef();
    const polygonRef = useRef();

    let new_polygons = []

    let centerMoved = function(v){
        let c = this.getCenter()
        let center = {lat: c.lat(), lng: c.lng(), zoom: this.getZoom() }
        localStorage.setItem('MAP_DEFAULT_CENTER', JSON.stringify(center))

        //console.log('centerMoved')
        //console.log(center)
    }

    let getDefaultCenter = function(){

        if(defaultZoom==undefined || defaultCenter==undefined){

            defaultZoom = 8
            defaultCenter = config.MAP_DEFAULT_CENTER ///{lat: -34.397, lng: 150.644}
            try{
                let defaultCenter2 = JSON.parse( localStorage.getItem('MAP_DEFAULT_CENTER'))
                if(defaultCenter2){
                    defaultCenter = defaultCenter2
                    if(defaultCenter2.zoom) defaultZoom = defaultCenter2.zoom
                }
                //console.log('GET MAP_DEFAULT_CENTER');
                //console.log(defaultCenter2)
            }catch(e){}

        }

    }

    const onLoadDrawingManager = drawingManager => {
        //alert('onLoadDrawingManager')
        //drawingManagerRef.current = drawingManager;
    }

    const getDrawingManagerOptions = ()=>{

        let drawingManagerEnabled = false
        if(props.geofencePaintID){
            drawingManagerEnabled = true
        }

        let color = '#ff0000'
        let geofence = getObjectByID(props.geofencePaintID, props.geofences)
        if(geofence){
            color = decimalColorToHexColor(geofence.Color)
        }

        const polygonOptions = {
            fillOpacity: 0.3,
            fillColor: color,
            strokeColor: color,
            strokeWeight: 2,
            draggable: true,
            editable: true
        }
    
        const drawingManagerOptions = {
            polygonOptions: polygonOptions,
            drawingControl: drawingManagerEnabled, //true,
            drawingControlOptions: {
                position: window.google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [
                    window.google.maps.drawing.OverlayType.POLYGON
                ]
            }
        }

        //console.log('getDrawingManagerOptions')
        //console.log(drawingManagerOptions)
        return drawingManagerOptions
    }

    


    const startDrawMode = (arg) => {
        var fillColor = arg;

        //setFillColor(fillColor);
        //drawingManager.setMap(map);
        //finishDrawingDiv.style.display = 'block';

        //for (var j = 0; j < all_overlays.length; j++) {
        //    var shape = all_overlays[j];
        //    if (shape.id == drawtoolid) {
        //        drawingManagerRef.setDrawingMode(null);
        //        return;
        //    }
        //}
        //drawingManagerRef.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
    }

    const onOverlayComplete = (overlayEvent) => {

        //alert('onOverlayComplete')
        //console.log('onOverlayComplete')
        //console.log(overlayEvent)

        /*
        drawingManagerRef.current.setDrawingMode(null);
        if ($overlayEvent.type === window.google.maps.drawing.OverlayType.POLYGON) {
            const newPolygon = $overlayEvent.overlay.getPath()
                .getArray()
                .map(latLng => ({ lat: latLng.lat(), lng: latLng.lng() }))

            // start and end point should be same for valid geojson
            const startPoint = newPolygon[0];
            newPolygon.push(startPoint);
            $overlayEvent.overlay?.setMap(null);
            setPolygons([...polygons, newPolygon]);
        }
        */
    }

    const onPolygonComplete = (polygon) => {

        //alert('onPolygonComplete')
        //console.log('onPolygonComplete')
        //console.log(polygon)

        //let path = getPolygonPath(polygon)
        //new_polygons.push(polygon)
        let shape = getShape(getPolygonPath(polygon))
        //console.log('onPolygonComplete')
        //console.log(shape)

        polygon.setMap(null)

        props.onAction({type:'GEOFENCE_ADD_SHAPE', id: props.geofencePaintID,  shape: shape})

    }

    const startDraw = () => {
        //alert('startDraw')
        //console.log('drawingManagerRef')
        //console.log(drawingManagerRef)

        setDrawingManagerEnabled(true)

        new_polygons = []

        //drawingManagerRef.current.setOptions({drawingControl:true})
    }

    const stopDraw = () => {
        //alert('stopDraw')

        updateCurrentPolygon();

        props.onAction({type:'GEOFENCE_SWITCH_PAINT_TOOL', id: props.geofencePaintID })

        //setDrawingManagerEnabled(false);

        return

        /*
        let paths = getPolygonPaths(polygonRef.current)
        //merge paths

        for(let i=0; new_polygons.length<i; i++){
            new_polygons[i].setEditable(false);
            //console.log(new_polygons[i])
            alert('new_polygons[i]')
        }

        let new_paths = new_polygons.map(polygon=>( getPolygonPath(polygon)))
        //console.log('new_paths')
        //console.log(new_paths)
        //let path = getPolygonPath(polygon)
        let all_paths = paths.concat(new_paths)

        let shapes = getShapes(all_paths)

        //console.log('shapes')
        //console.log(shapes)

        //props.onAction({type:'GEOFENCE_UPDATE_SHAPES', id: props.geofencePaintID, shapes: shapes})
        props.onAction({
            type:'GEOFENCE_SET_PROPERTY', 
            id: props.geofencePaintID, 
            name: 'Shapes', 
            value: shapes
        })
        //props.onAction({type:'GEOFENCE_SWITCH_PAINT_TOOL', id: props.geofencePaintID })

        setDrawingManagerEnabled(false)
        //drawingManagerRef.current.setOptions({drawingControl:false})
        */
    }

    const deleteShape = function() {

        props.onAction({
            type:'GEOFENCE_DELETE_SHAPE', 
            id: props.geofenceSelectedShape.id, 
            index: props.geofenceSelectedShape.index
        })
        //props.geofenceSelectedShape.id===polygon.geofence.ID &&
        //props.geofenceSelectedShape.index===polygon.index
    }

    const getPolygonPaths = (polygon)=>{
        let pathsArr = []
        if(polygon){
            let paths = polygon.getPaths()

            //console.log('paths')
            //console.log(paths)

            if(paths){

                let a = paths.getArray()
                //console.log('a')
                //console.log(a)

                for(let i=0; i<a.length; i++ ){
                    let path = a[i]
                    //console.log('path')
                    //console.log(path)

                    let poly = []
                    for(let j=0; j<path.length; j++){
                        let pt = path.getAt(j);
                        poly.push({lat: pt.lat(), lng: pt.lng()})
                    }
                    //console.log('poly')
                    //console.log(poly)

                    pathsArr.push(poly)
                }
            }
            
        }
        //console.log('getPolygonPaths pathsArr')
        //console.log(pathsArr)
        return pathsArr
    }

    const getPolygonPath = (polygon) =>{
        const p = polygon.getPath();
        const l = p.getLength();

        let path = []
        for(let i=0; i<l; i++){
            let pt = p.getAt(i);
            path.push({lat: pt.lat(), lng: pt.lng()})
        }
        //console.log('getPolygonPath path')
        //console.log(path)
        return path
    }

    const getPoligonOptions = (geofence, selected) => {
        //console.log('getPoligonOptions')

        //console.log(geofence.ID)
        //console.log(props)
        //console.log(props.geofencePaintID)

        let options = {
            strokeColor: decimalColorToHexColor(geofence.Color),
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: decimalColorToHexColor(geofence.Color),
            fillOpacity: 0.5,
            editable: selected ? true : false
        }

        //console.log(options)

        return options
    }

    const getPaths = (shapes) => {
        //console.log('getPaths')
        //console.log(shapes)
        let paths = []
        if(typeof shapes === 'string'){
            let arr = shapes.split('|')
            //console.log('arr')
            //console.log(arr)
            for(let i=0; i<arr.length; i++ ){
                let shape = arr[i]
                if(!shape) continue

                shape = String(shape).replaceAll('lng', '"lng"');
                shape = String(shape).replaceAll('lat', '"lat"');
                //console.log('shape')
                //console.log(shape)
                let path = JSON.parse(shape)
                paths.push(path)
            }
        }else{
            return shapes
        }

        return paths
    }


    const getShapes = (paths) => {
        //console.log('getShapes')
        //console.log(paths)

        let shapes = []
        for(let i=0; i<paths.length; i++){
            let path = paths[i]
            let shape = getShape(path)
            //console.log('shape')
            //console.log(shape)

            shapes.push(shape)
        }

        return shapes.join('|')
    }

    const getShape = (path) => {
        let shape = JSON.stringify(path);
        //console.log(json);
        //console.log(polygon);
        shape = String(shape).replaceAll('"lng"', 'lng');
        shape = String(shape).replaceAll('"lat"', 'lat');

        return shape
    }

    const updateCurrentPolygon = () => {
        if(polygonRef && polygonRef.current){

            let path = getPolygonPath(polygonRef.current)

            let shape = getShape(path)

            props.onAction({
                type: 'GEOFENCE_UPDATE_SHAPE',
                id: props.geofenceSelectedShape.id,
                index: props.geofenceSelectedShape.index,
                shape: shape
            })
        }
    }

    const renderPolygons = () => {

        let polygons = []
        for(let i=0; i<props.geofences.length; i++){

            let geofence = props.geofences[i]

            let paths = getPaths(geofence.Shapes)

            if(!paths) continue;

            for(let j=0; j<paths.length; j++){

                let path = paths[j]

                let obj = {
                    geofence: geofence,
                    index: j,
                    path: path
                }

                polygons.push(obj)
            }
        }

        const isSelectedPolygon = (polygon) => {
            return props.geofenceSelectedShape && 
                props.geofenceSelectedShape.id===polygon.geofence.ID &&
                props.geofenceSelectedShape.index===polygon.index
        }

        /*
        const isCurrentPolygon = (polygon) => {
            return props.geofencePaintID==polygon.geofence.ID &&
                props.geofenceSelectedShape.id==polygon.geofence.ID &&
                props.geofenceSelectedShape.index==polygon.index
        }
        */

        return polygons.map( 
            polygon => (
                <>
                {isSelectedPolygon(polygon) ? (
                    <Polygon 
                        key={polygon.geofence.ID+'_'+polygon.index} 
                        id={polygon.geofence.ID+'_'+polygon.index} 
                        visible={polygon.geofence.ShowOnMap} 
                        options={getPoligonOptions(polygon.geofence, true)}
                        ref={polygonRef}
                        path={polygon.path}></Polygon>
                ):(
                    <Polygon 
                        key={polygon.geofence.ID+'_'+polygon.index} 
                        id={polygon.geofence.ID+'_'+polygon.index} 
                        visible={polygon.geofence.ShowOnMap} 
                        options={getPoligonOptions(polygon.geofence, false)}
                        path={polygon.path}
                        onClick={(event)=>{
                            if(!isSelectedPolygon(polygon) && props.geofencePaintID==polygon.geofence.ID){
                                //alert(polygon.geofence.ID+'_'+polygon.index)
                                updateCurrentPolygon()

                                props.onAction({
                                    type:'GEOFENCE_SELECT_SHAPE', 
                                    id:polygon.geofence.ID, 
                                    index:polygon.index
                                })
                            }else{
                               mapClick(event)
                            }
                        }}
                        ></Polygon>
                )}
                </>
            )
            
        )

    }

    let polyline = props.track ? 
        (
<Polyline
    path={ props.track.points.map(point => ({lat:point.latitude, lng:point.longitude}) )   }
    geodesic={true}
    options={{
        strokeColor: "#ff2527",
        strokeOpacity: 0.75,
        strokeWeight: 2
    }}/>
        ) : '' 



        let polygons = props.geofences ? renderPolygons() : ''
        /*
    let polygons = props.geofences ? (
        <>
        {props.geofences.map( 
            geofence => (
                <>
                {props.geofencePaintID==geofence.ID?(
                    <Polygon key={geofence.ID} 
                    id={geofence.ID} 
                    visible={geofence.ShowOnMap} 
                    options={getPoligonOptions(geofence)}
                    ref={polygonRef}
                    paths={getPaths(geofence.Shapes)}></Polygon>
                ):(
                    <Polygon key={geofence.ID} 
                    id={geofence.ID} 
                    visible={geofence.ShowOnMap} 
                    options={getPoligonOptions(geofence)}
                    paths={getPaths(geofence.Shapes)}></Polygon>
                )}
                </>
            ))}
        </>
    ):''
*/


    getDefaultCenter()
    center = defaultCenter
    zoom = defaultZoom

    let currentMarker = null
    if(props.markers && props.markers.length){
        const marker = props.markers[0]
        center = {lat: marker.lat, lng: marker.lng}
        zoom = 16

        let currentMarker = null
        if(currentMarkerID){
            currentMarker = getObjectByID(currentMarkerID, props.markers, 'id')
        }
    }

    const button_style = {
        backgroundColor:'white',
        margin: 5
    }

    const mapClick = function (e){
        //console.log(e)
        //alert('mapClick '+ e.latLng.lat() +' '+e.latLng.lng())

        props.onAction({type:'MAP_CLICK', lat: e.latLng.lat(), lng: e.latLng.lng()})

    }

    /**
     * google.maps.event.addDomListener(document, 'keyup', function (e) {
                var code = (e.keyCode ? e.keyCode : e.which);
                if (code === 46) deleteSelectedShape();
            });
     */
    

    return (
        <Paper>

            <GoogleMap
                defaultZoom={8}
                defaultCenter={defaultCenter}
                center={center}
                zoom={zoom}
                onDragEnd={centerMoved}
                onClick={mapClick}
            >

                <div style={{position: 'relative', bottom: 20, width:'100%', textAlign:'center'}}>
                    {/*<Button style={button_style} variant="outlined" onClick={()=>startDraw()}>Start draw</Button>*/}

                    {props.geofencePaintID? 
                        <Button style={button_style} variant="outlined" onClick={()=>stopDraw()}>Finish draw</Button>
                    : null}
                    {props.geofenceSelectedShape ? 
                        <Button style={button_style} variant="outlined" onClick={()=>deleteShape()}>Delete polygon</Button>
                    : null}
                </div>

                {props.markers.map(marker=>
                    <Marker key={marker.id} 
                        onClick={()=>{
                            setMarker(marker.id)
                            setInfoVisibility(true)
                            setTick(tick + 1) // force update
                        }}
                        title={marker.title} 
                        label={marker.label} 
                        position={{lat: marker.lat, lng: marker.lng}}>
                    </Marker>
                )}

                {infoVisibility && currentMarker?
                    <MarkerInfo 
                        t={props.t}
                        tick={tick}
                        marker={currentMarker} 
                        visible={infoVisibility}
                        onCloseClick={setInfoVisibility} />
                : null}


                {polyline}
                {polygons}

                <DrawingManager
                    ref={drawingRef}
                    onLoad={onLoadDrawingManager}
                    onOverlayComplete={onOverlayComplete}
                    onPolygonComplete={onPolygonComplete}
                    options={getDrawingManagerOptions()}
                />


                {props.kmlLayers.map(layer => (
                    layer.ShowOnMap ? <KmlLayer 
                            key={layer.ID} 
                            url={layer.CurrentUrl ? layer.CurrentUrl : layer.Url}
                            options={{preserveViewport:true}}
                            ></KmlLayer> : null
                ))}
                {/*<KmlLayer url='http://www3.ru09.ru/'></KmlLayer>*/}

            </GoogleMap>
        </Paper>
    )

        /*
    }else{
        defaultZoom = 8
        defaultCenter = config.MAP_DEFAULT_CENTER ///{lat: -34.397, lng: 150.644}
        try{
            let defaultCenter2 = JSON.parse( localStorage.getItem('MAP_DEFAULT_CENTER'))
            if(defaultCenter2){
                defaultCenter = defaultCenter2
                if(defaultCenter2.zoom) defaultZoom  = defaultCenter2.zoom
            }
            //console.log('GET MAP_DEFAULT_CENTER');
            //console.log(defaultCenter2)
        }catch(e){}


        return (
            <Paper>

                <Button onClick={()=>startDraw()}>Start draw</Button>
                <Button onClick={()=>stopDraw()}>Stop draw</Button>

                <GoogleMap
                    defaultZoom={defaultZoom}
                    defaultCenter={defaultCenter}
                    onDragEnd={centerMoved}

                    center={center}
                    zoom={zoom}
                >
                    {polyline}
                
                    <DrawingManager
                        onLoad={onLoadDrawingManager}
                        onOverlayComplete={onOverlayComplete}
                        options={getDrawingManagerOptions()}
                    />
                
                
                </GoogleMap>
            </Paper>
        )
    }
        */

}))


const MarkerInfo = (props)=>{

    const {marker, visible, onCloseClick} = props

    const styles = {
        h3: { },
        p: {
            margin: '2px',
            whiteSpace: 'nowrap' 
        }
    }

    const t = props.t
    
    //  alert('MarkerInfo')
    //console.log('MarkerInfo props')
    //console.log(props)
    return (
        <InfoWindow
            tick={props.tick}
            style={{overflow:'auto'}}
            position={{lat: marker.lat, lng: marker.lng}}
            onCloseClick={()=>{onCloseClick(false)}}
            visible={visible}>
                <div style={{width:150}}>
                    <h3 style={styles.h3}>{marker.label}</h3>
                    <p style={styles.p}>{t('Latitude')}: {marker.lat.toFixed(5)}</p>
                    <p style={styles.p}>{t('Longitude')}: {marker.lng.toFixed(5)}</p>
                    
                    {marker.speed?
                    <p style={styles.p}>{t('Speed')}: {formatSpeed(marker.speed)}</p>
                    : null}
                    {marker.alt?
                    <p style={styles.p}>{t('Altitude')}: {marker.alt.toFixed(1)+''+t('m')}</p>
                    : null}
                    {marker.accuracy?
                    <p style={styles.p}>{t('Accuracy')}: {marker.accuracy.toFixed(1)+''+t('m')}</p>
                    : null}
                    <p style={styles.p}>{t('Time')}: {formatDateTime(marker.time, 'time')}</p>
                </div>
        </InfoWindow>
    )

}

//export const MapPanel = withGoogleMap()(MapPanel_);

//withTranslation()